import React from 'react'
import Lottie from 'lottie-react'
import animationData from '../../assets/Animation - 1707422483141.json'
export default function ContactUsAnimation() {
  return (
    <div>
        <Lottie animationData={animationData} />
      
    </div>
  )
}
